import React, { useState, useEffect } from 'react';
import LeftNav from '../LeftNav/LeftNav';
import { useAuth } from '../../AuthContext';
import { useParams } from 'react-router-dom';
import { cn } from '../../../lib/utils';

const MainLayout = ({ children, fullWidth }) => {
  const [navExpanded, setNavExpanded] = useState(true);
  const { tenantDomain } = useParams();
  const { updateTenantDomain } = useAuth();

  useEffect(() => {
    updateTenantDomain(tenantDomain);
  }, [tenantDomain]);

  return (
    <div className="min-h-screen bg-background">
      <LeftNav expanded={navExpanded} onToggle={() => setNavExpanded(!navExpanded)} />
      <main
        className={cn(
          "transition-all duration-300",
          navExpanded ? "ml-56" : "ml-14",
          fullWidth ? "" : "p-8"
        )}
      >
        {children}
      </main>
    </div>
  );
};

export default MainLayout;
